module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_orange_06-24d653efe77277fa4478b07077bab7db.svg";